import { getAuthClient } from './authClient'
import { configEnum, ConfigType, types } from '../enums/fetchFactoryEnum'
import httpResponse from '../enums/httpResponseEnum'
import localStorageEnum from '../enums/localStorageEnum'

interface ConfigModel {
	method: ConfigType,
	body?: any,
	headers?: HeadersInit
}

const fetchFactory = (
	lien: string,
	config: ConfigModel = {
		method: configEnum.get
	},
	type: types = types.json
) => {
	const {
		headers,
		...others
	} = config
	const AuthClient = getAuthClient()

	return new Promise(
		(resolve, reject) => {
			// Vérification de la validité du token
			AuthClient.tokenManager.get('accessToken')
				.then(
					(token: any) => {
						// Si le token est valide, on initialise les header et on fetch
						if (token) {
							const defaultHeaders: HeadersInit = {
								Accept: 'application/json',
								'activityLine': process.env.REACT_APP_TARGET || '',
								'residences': localStorage.getItem('residences') || '[]',
								'buildings': localStorage.getItem('buildings') || '[]'
							}

							defaultHeaders.Authorization = `Bearer ${token.value}`

							const newConfig = {
								headers: {
									...defaultHeaders,
									...headers
								},
								...others
							}

							fetch(lien, newConfig)
								.then(
									response => {
										if (response.ok) {
											if (type === types.json) {
												response.json()
													.then(
														(data: any) => {
															resolve(data)
														}
													)
											}
											if (type === types.blob) {
												response.blob()
													.then(blob => {
														resolve(blob)
													})
											}
											if (type === types.response) {
												resolve(response)
											}
										} else {
											if (response.statusText === httpResponse.unauthorized && response.status === 401) {
												AuthClient.signOut(
													{
														postLogoutRedirectUri: JSON.parse(localStorage.getItem(localStorageEnum.commonUri) || '').login_uri || ''
													}
												)
											} else {
												response.json()
													.then(
														(data: any) => {
															reject(data)
														}
													)
													.catch(
														(error: any) => {
															reject(error)
														}
													)
											}
										}
									}
								)
								.catch(
									(error: any) => {
										reject(error)
									}
								)
						} else {
							AuthClient.signOut(
								{
									postLogoutRedirectUri:  JSON.parse(localStorage.getItem(localStorageEnum.commonUri) || '').login_uri || ''
								}
							)
						}
					}
				)
				.catch(
					(err: any) => {
						console.error('Une erreur est survenue lors de la récupération du token : ', err)
						AuthClient.signOut(
							{
								postLogoutRedirectUri:  JSON.parse(localStorage.getItem(localStorageEnum.commonUri) || '').login_uri || ''
							}
						)
					}
				)
		}
	)
}

export default fetchFactory
